module.exports = __webpack_public_path__ + "static/media/Wartortle_gaussian2.129128c5.png";